var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('youtube',{ref:"youtube",attrs:{"video-id":_vm.videoData.id,"player-vars":_vm.playerVars,"width":"100%","height":"100%"},on:{"ready":_vm.onReady}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }